// removed by extract-text-webpack-plugin
module.exports = {"button":"index__button___eMuHc","primary":"index__primary___dhX7w","accent":"index__accent___1tAh4","disabled":"index__disabled___ohqRW","inverse":"index__inverse___16V2m","noLetterSpacing":"index__noLetterSpacing___YJTr0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Button/index.css
// module id = 971
// module chunks = 37